export enum TicketType {
    jiraTicket = 'jiraTicket',
    oplossenKlacht = 'oplossenKlacht',
    perfectviewTicket = 'perfectviewTicket',
}
